<ion-header lines="none">
  <ion-toolbar>
    <ion-title class="text-center color-dark" data-cy="editInputAddress-form-title">{{dialogLabel}}</ion-title>

    <ion-buttons slot="start">
      <ion-button class="toolbarButton" (click)="dismiss()" data-cy="editInputAddress-toolbar-dismiss">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <ion-button *ngIf="userRole !== 'agentAdmin'" class="toolbarButton" color="primary" (click)="done()" [disabled]="(restrictCreation 
        || autoCompleteAddress?.title?.trim().length === 0 
        || addressState === '') 
        || (userRole ==='lender' && !agent)" data-cy="editInputAddress-toolbar-save">
        Save
      </ion-button>

      <ion-button *ngIf="userRole === 'agentAdmin'" class="toolbarButton" color="primary" (click)="done()" [disabled]="(restrictCreation 
      || autoCompleteAddress?.title?.trim().length === 0 
      || addressState === '') 
      || !totalPairedAgents?.length" data-cy="editInputAddress-toolbar-save">
        Save
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content padding>
  <div class="search-bar">
    <ion-searchbar #ionSearchbar [(ngModel)]="autoCompleteAddress.title" (ionClear)="clear()"
      (ionChange)="addressFieldChange();" (ionInput)="updateSearchResults()" placeholder="Enter listing address"
      data-cy="editInputAddress-form-input" search-icon="location-outline">
    </ion-searchbar>
    <ion-list class="search-item" lines="none" *ngIf="autocompleteItems.length !== 0 && itemSelected !== true">
      <ion-item lines="none" *ngFor="let item of autocompleteItems" tappable (click)="selectSearchResult(item)">
        {{ item.description }}
      </ion-item>
    </ion-list>
  </div>

  <div class="stateSelectDiv" *ngIf="autoCompleteAddress.title !== '' && (addressInputChanged || offlineMode)">

    <ion-item class="stateIonItem">
      <ion-label data-cy="editInputAddress-form-state-lbl">State:</ion-label>
      <ion-select class="stateManualSelect" [(ngModel)]="addressState" name="addressState"
        (ionChange)="manualStateChange();" data-cy="editInputAddress-form-state-dd">

        <ion-select-option *ngFor="let state of states" value="{{state}}"
          [attr.data-cy]="'editInputAddress-form-state-' + state ">
          {{state}}
        </ion-select-option>
      </ion-select>
    </ion-item>

  </div>


  <div *ngIf="shouldDisplayAgentSelection()">
    <div class="agentsDiv">
      <div class="spacer-20"></div>
      <div *ngIf="showPairedAgentsDiv">
        <div class="selected-agents-text">
          <div>Agents</div>
          <div *ngIf="userRole === 'agentAdmin' && totalPairedAgents?.length > 0 && checkedAgentsId.length">
            {{totalPairedAgents.length}} selected</div>
        </div>

        <algolia-paired-agents-search 
          #algoliaAgentSearch
          [childComponent]="hitTemplate"
          (onLoad)="getPrimaryAgent()"
        />

        <ng-template #hitTemplate let-hit>
          <div class="button-icon-container">
            <div>
               <ion-checkbox 
                (ionChange)="selectedPairedAgent($event, hit)"
                [checked]="isAgentSelected(hit.objectID)"
                [disabled]="shouldCheckboxBeDisabled(hit.objectID)"
                [style.pointer-events]="isPrimaryAgent(hit.objectID) && !createMode ? 'none' : null"

                mode="ios"
                lines="none" 
                [color]="isPrimaryAgent(hit.objectID) ? 'primary' : 'medium'"                  
              />
            </div>

            <app-public-profile-item 
              [pairedAgentData]="hit"
              [showControls]="false" 
              [showContact]="false" 
              [attr.data-index]="i"
              class="listing-item hit-border"
            /> 
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="padding" *ngIf="restrictCreation && addressState">
    <p class="padding">You can only add listings located in one of your assigned states.</p>
  </div>

  <div [style.padding-bottom.px]="utils.keyboardHeight"></div>
</ion-content>